import React from "react";
import {Modal} from 'react-bootstrap';
import { useDispatch } from "react-redux";
import {isMobile} from 'react-device-detect';
const LargeModal = (props) => {
  const { children, header, show, closeFunction, className } = props;
  const dispatch = useDispatch();
  return (
    <Modal
      show={show}
      onHide={() => dispatch(closeFunction())}
      className={className ? className : ""}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header closeButton={false}>
        <Modal.Title id="contained-modal-title-vcenter custom-modal-title" style={isMobile ? {fontSize:'12px !important'} : {}}>
          {header}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
          {children}
      </Modal.Body>
    </Modal>
  );
};

export default LargeModal;
